import React, { useEffect, useRef } from 'react';
import './Features.css';

const Features = () => {
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('reveal-active');
          } else {
            entry.target.classList.remove('reveal-active');
          }
        });
      },
      { threshold: 0.1 }
    );

    // Header aur cards dono ko observe karega
    const elementsToAnimate = sectionRef.current.querySelectorAll('.animate-item');
    elementsToAnimate.forEach((el) => observer.observe(el));

    return () => observer.disconnect();
  }, []);

  const features = [
    {
      title: "Trusted Professionals",
      desc: "Verified IDs, licenses, and regular performance checks for all our doctors.",
      icon: "🛡️",
      glowColor: "#0062ff" // Dynamic glow color for each card
    },
    {
      title: "Live Doctor Tracking",
      desc: "See your doctor's ETA in real-time via GPS tracking on our app.",
      icon: "📍",
      glowColor: "#00d4ff"
    },
    {
      title: "Flexible Payments",
      desc: "Use UPI apps, debit/credit cards or wallets for secure payments.",
      icon: "💳",
      glowColor: "#0062ff"
    },
    {
      title: "24/7 Customer Support",
      desc: "We're always available via call, chat or email for any assistance.",
      icon: "🎧",
      glowColor: "#00d4ff"
    }
  ];

  return (
    <section className="features-section" id="features" ref={sectionRef}>
      <div className="section-background-glow"></div> {/* Parallax background */}
      
      {/* Animated Heading */}
      <div className="features-header animate-item delay-0">
        <span className="sub-heading-tag">Why Choose Us</span>
        <h2>Key Features of <span>The Doctor At Home</span></h2>
        <div className="underline-accent"></div>
      </div>

      <div className="features-grid">
        {features.map((item, index) => (
          <div key={index} className={`feature-glass-card animate-item delay-${index + 1}`} style={{'--card-glow-color': item.glowColor}}>
            <div className="card-dynamic-border"></div> {/* Dynamic glowing border */}
            <div className="card-content-wrapper">
                <div className="feature-icon-sphere">{item.icon}</div>
                <h3>{item.title}</h3>
                <p>{item.desc}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Features;